import { createStore } from "vuex";

export default createStore({
  state: {
    urlImagenSandwich: [],
    urlImagenHotcake: [],
    urlImagenAvena: [],
    urlImagenOmelette: [],
    urlImagenPlatoFuerte: [],
    urlImagenEnsalada: [],
    urlImagenBebida: [],
  },

  mutations: {
    getFotos(state, urlFoto) {
      if (!Array.isArray(urlFoto)) return;

      state.urlImagenSandwich = [];
      state.urlImagenHotcake = [];
      state.urlImagenAvena = [];
      state.urlImagenOmelette = [];
      state.urlImagenPlatoFuerte = [];
      state.urlImagenEnsalada = [];
      state.urlImagenBebida = [];

      for (const iterator of urlFoto) {
        switch (iterator.tipo) {
          case 1:
            state.urlImagenSandwich.push(iterator);
            break;
          case 2:
            state.urlImagenHotcake.push(iterator);
            break;
          case 3:
            state.urlImagenAvena.push(iterator);
            break;
          case 4:
            state.urlImagenOmelette.push(iterator);
            break;
          case 5:
            state.urlImagenPlatoFuerte.push(iterator);
            break;
          case 6:
            state.urlImagenBebida.push(iterator);
            break;
          case 7:
            state.urlImagenEnsalada.push(iterator);
            break;
          default:
            console.log("no existe la imagen");
            break;
        }
      }
    },
  },
  actions: {
    obtenerImagenes: async function ({ commit }) {
      try {
        let baseUrl = process.env.VUE_APP_API_URL || "https://thefitgym.dyndns.org:3000/pagina_services/fitbar";
        if (typeof window !== "undefined" && window.location && window.location.hostname) {
          const currentHost = window.location.hostname;
          baseUrl = baseUrl.replace("localhost", currentHost).replace("127.0.0.1", currentHost);
        }
        const data = await fetch(`${baseUrl}/getMenu.php`);
        const fotos = await data.json();
        commit("getFotos", fotos);
      } catch (err) {
        console.error("Error cargando el menú de FitBar:", err);
      }
    },
  },
});
